<template>
  <div>
    <!-- 清理商品 -->
    <baseBreadcrumb :page="$t('message.cleanUpGoods')" :menu="$t('message.warehouse')"></baseBreadcrumb>
    <!-- 主体 -->
    <div class="body">
      <!-- 搜索 -->
      <div class="search">
        <div class="row">
          <!-- 初始时间 -->
          <div class="item">
            <el-date-picker v-model="datas.dateStart" type="datetime" :placeholder="$t('message.CStime')"
              default-time="00:00:00" value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </div>
          <!-- 结束日期 -->
          <div class="item">
            <el-date-picker v-model="datas.dateEnd" type="datetime" :placeholder="$t('message.dateClosed')"
              default-time="23:59:59" value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </div>
          <!-- 物流号 -->
          <div class="item">
            <el-input v-model="datas.express_no" :placeholder="$t('message.logisticsNumber')"></el-input>
          </div>
          <!-- 交易号 -->
          <div class="item">
            <el-input v-model="datas.purchase_no" :placeholder="$t('message.transactionNumber')" clearable
              onfocus="this.select()"></el-input>
          </div>

          <!-- 订单号 -->
          <div class="item">
            <el-input v-model="datas.order_sn" :placeholder="$t('message.orderNumber')" clearable
              onfocus="this.select()"></el-input>
          </div>
          <!-- 客户ID -->
          <div class="item">
            <el-input v-model="datas.user_id" :placeholder="$t('message.clientID')" clearable
              onfocus="this.select()"></el-input>
          </div>
        </div>
        <div class="row">
          <!-- 人员范围 -->
          <div class="item">
            <cascader @setUserList="setUserList" :org_id="datas.org_id" ref="cascader" />
          </div>
          <div class="item">
            <!--  全部人员-->
            <el-select v-model="datas.admin_id" :placeholder="$t('message.allPersonnel')" filterable clearable>
              <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <!-- 搜索 -->
          <el-button type="primary" @click="search">
            {{ $t("message.ok") }}
          </el-button>
          <!-- 重置 -->
          <!-- <el-button @click="reset">
            {{ $t("message.reset") }}
          </el-button> -->
        </div>
      </div>

      <!-- 列表 -->
      <div class="table" v-if="show">
        <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%" @selection-change="handleSelectionChange"
          ref="multipleTable" @cell-click="labelSelection" size="small">
          <el-table-column align="center" label="NO" width="45" prop="rowNumber" fixed="left">
          </el-table-column>
          <el-table-column type="selection" width="45" align="center" fixed="left">
          </el-table-column>
          <!-- 清理时间 -->
          <el-table-column align="center" :label="$t('message.cleanUpTime')" prop="created_at" width="165px">
          </el-table-column>
          <!-- 清理人 -->
          <el-table-column align="center" :label="$t('message.theCleaner')" prop="admin.realname">
          </el-table-column>

          <!-- 订单编号 -->
          <el-table-column align="center" :label="$t('message.orderNumber')" width="140px">
            <template slot-scope="scope">
              <p>
                <router-link :to="
                  '/orderPaymentDetail?order_sn=' +
                  scope.row.order_purchase.order_sn
                " target="_blank" style="color: #fa5058">{{ scope.row.order_purchase.order_sn }}</router-link>
              </p>
              <p>{{ scope.row.order_purchase.order.user.realname }}</p>
            </template>
          </el-table-column>

          <!-- 番号 -->
          <el-table-column align="center" :label="$t('message.mash')" prop="order_purchase.order_detail.sorting"
            width="50">
          </el-table-column>

          <!-- 照片 -->
          <el-table-column align="center" :label="$t('message.pic')" prop="floor">
            <template slot-scope="scope">
              <el-popover placement="right" width="300" trigger="hover">
                <img :src="scope.row.order_purchase.order_detail.pic" alt="" style="width: 300px; height: 300px" />
                <a :href="`https://detail.1688.com/offer/${scope.row.order_purchase.order_detail.goods_id}.html`"
                  target="_blank" slot="reference">
                  <img :src="scope.row.order_purchase.order_detail.pic" alt="" style="width: 60px; height: 60px" />
                </a>
              </el-popover>
            </template>
          </el-table-column>
          <!-- 规格 -->
          <el-table-column align="center" :label="$t('message.specification')">
            <template slot-scope="scope">
              <div class="template">
                <el-tooltip placement="bottom">
                  <div slot="content">
                    <div class="row" v-for="(itemDetail, itemIndex) in scope.row.order_purchase
                      .order_detail.detail_y" :key="itemIndex" style="margin-bottom: 5px">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                  <div>
                    <div class="row" v-for="(itemDetail, itemIndex) in scope.row.order_purchase
                      .order_detail.detail_y" :key="itemIndex">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>

          <!-- 清理数量 -->
          <el-table-column align="center" :label="$t('message.quantityOfClearance')" prop="num">
          </el-table-column>
          <!-- 单价(元) -->
          <el-table-column align="center" :label="$t('message.unitPrice')"
            prop="order_purchase.order_detail.confirm_price">
          </el-table-column>
          <!-- 交易号/物流号 -->
          <el-table-column align="center" :label="$t('message.transactionNumberLogisticsNumber')" width="180px">
            <template slot-scope="scope">
              <div class="template">
                <p>JY：{{ scope.row.order_purchase.purchase_no }}</p>
                <p v-for="(item, index) in scope.row.order_purchase
                  .order_purchase_express" :key="index">
                  WL{{ index + 1 }}：{{ item.express_no }}
                </p>
              </div>
            </template>
          </el-table-column>
          <!-- 订单操作人员 -->
          <el-table-column align="center" :label="$t('message.orderOperato')" width="120">
            <template slot-scope="scope">
              <div class="template">
                <p>
                  {{ $t("message.business") }}:{{
                    scope.row.order_purchase.order.y_admin.realname
                  }}
                </p>
                <p>
                  {{ $t("message.purchase") }}:{{
                    scope.row.order_purchase.order.g_admin.realname
                  }}
                </p>
                <p>
                  {{ $t("message.distribution") }}:{{
                    scope.row.order_purchase.order.p_admin.realname
                  }}
                </p>
              </div>
            </template>
          </el-table-column>
          <!-- 商品备注 -->
          <el-table-column align="center" :label="$t('message.commodityNote')" prop="status_name" width="100">
            <template slot-scope="scope">
              <el-button size="small" class="primary" type="primary" @click="look(scope.row)">{{ $t("message.look")
              }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 商品备注 -->
    <commodityNote v-if="commodityNoteDialogVisible" :commodityNoteData="commodityNoteData" :title="'内部商品备注'" />
  </div>
</template>
<script>
import commodityNote from "@/components/common/commodityNote";
export default {
  components: {
    commodityNote,
  },
  data() {
    return {
      show: false,
      datas: { status: "" },

      userList: [],
      tableData: [],
      total: 0,
      selectList: [],
      wasteGoodsDialogVisible: false, //商品废弃
      remarkDialogVisible: false, //商品备注
      commodityNoteDialogVisible: false,
      commodityNoteData: {},
    };
  },
  created() {
    this.toClearList();
  },
  methods: {
    // 常规,辅料,备品
    toClearList() {
      this.show = false;
      this.$api.warehouseApi.toClearList(this.datas).then((res) => {
        res.data.data.forEach((item) => { });
        this.tableData = res.data.data;
        this.total = res.data.total;
        this.show = true;
      });
    },

    // 人员范围
    setUserList(data) {
      this.userList = data.userList;
      this.datas.admin_id = "";
    },
    // 分页
    handleCurrentChange(val) {
      this.data.page = val;
      this.toClearList();
    },
    handleSizeChange(val) {
      this.data.pageSize = val;
      this.toClearList();
    },
    // 搜索
    search() {
      this.datas.page = 1;
      this.toClearList();
    },
    // 重置
    reset() {
      this.startDate = "";
      this.dateClosed = "";
      this.datas = {
        page: 1,
        pageSize: 10,
        status: "",
        express_no: "",
        purchase_no: "",
        order_sn: "",
        user_id: "",
        dateStart: "",
        dateEnd: "",
      };
      this.$refs.cascader.orgId = [];

      this.$forceUpdate();
      this.toClearList();
    },

    // 整个框选择
    labelSelection(row, column) {
      if (column.className == "el-table-column--selection") {
        this.$refs.multipleTable.toggleRowSelection(row);
      }
    },
    handleSelectionChange(val) {
      this.selectList = val;
    },
    // 查看备注
    look(item) {
      this.commodityNoteData = {
        p_remark: item.order_purchase.order_detail.p_remark,
        g_remark: item.order_purchase.order_detail.g_remark,
        y_remark: item.order_purchase.order_detail.y_remark,
      };
      this.commodityNoteDialogVisible = true;
    },
  },
};
</script>
<style lang='scss' scoped>
.search {
  margin-top: 10px;
  position: relative;

  .row {
    display: flex;
    margin-bottom: 16px;

    .item {
      width: 180px;
      margin-right: 24px;
    }

    /deep/.el-date-editor {
      width: 100%;

      .el-input__inner {
        padding-right: 0;
      }
    }
  }
}

.template {
  width: 100%;
  text-align: left;
}
</style>